import { useEffect } from 'react';
import { ErrorResponseBody } from 'api-paths-cas';

export function useHandleRegisterApplicantError(
  setError: (name: string, error: { type: string; message: string }) => void,
  applicantError: string | ErrorResponseBody,
) {
  useEffect(() => {
    if (!applicantError) return;

    const err = typeof applicantError === 'string' ? null : applicantError.error;

    if (err && typeof err === 'object' && 'issues' in err) {
      const issues = err.issues ?? [];
      for (const issue of issues) {
        const path = (issue?.path || []).join('.');
        const message = issue?.message || 'Invalid value';
        if (path) {
          setError(path, { type: 'server_side', message });
        }
      }
    }
  }, [applicantError, setError]);
}
